import React from "react";
import styles from "./FlotteDetail.module.scss";
import {
  formatValue,
  getCategoryIcon,
  getValueFromPath,
} from "./FlotteDetailUtils";
import useFlotteDetail from "./useFlotteDetail";

const FlotteDetail = ({ item }) => {
  // Helper function pour récupérer une valeur à partir d'un chemin d'accès
  const { categorizedColumns } = useFlotteDetail({ item });

  return (
    <div className={styles.flotteDetail}>
      <div className="row">
        {Object.entries(categorizedColumns).map(([category, columns]) => {
          // Filtrer les colonnes qui ont une valeur non vide
          const visibleColumns = columns.filter((column) => {
            const value = getValueFromPath(item, column.path);
            return value !== null && value !== undefined && value !== "";
          });

          // Ne pas afficher la carte si aucune colonne n'a de valeur
          if (visibleColumns.length === 0) return null;

          return (
            <div key={category} className="col-md-6 mb-4">
              <div className={`card h-100 ${styles.section}`}>
                <div className="card-header">
                  <h6 className="mb-0">
                    <i className={`fa ${getCategoryIcon(category)} mr-2`} />
                    {category}
                  </h6>
                </div>
                <div className="card-body">
                  {visibleColumns.map((column) => {
                    const value = getValueFromPath(item, column.path);
                    const formattedValue = formatValue(
                      value,
                      column.type,
                      column.key,
                      item
                    );

                    return (
                      <div key={column.key} className={styles.detailRow}>
                        <span className={styles.label}>{column.title} :</span>
                        <span
                          className={`${styles.value} ${
                            column.key === "immatriculation"
                              ? "font-weight-bold"
                              : ""
                          }`}
                        >
                          {formattedValue}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FlotteDetail;
